// extracted by mini-css-extract-plugin
module.exports = {"authLayout":"auth-layout_authLayout__y_NRi","topbar":"auth-layout_topbar___g4PW","content":"auth-layout_content__4USKH","footer":"auth-layout_footer__7b5QU"};